// Колода v2 (scripts/cards/stylize.py): карта названия (как в БД) -> картинка лица карты.
// Файлы лежат в frontend/public/cards/v2/, рубашка — /assets/card-back.webp.
export const CARD_IMAGES={
  'Башня':'/cards/v2/bashnya.webp',
  'Четвёрка Кубков':'/cards/v2/chetvyorka-kubkov.webp',
  'Четвёрка Мечей':'/cards/v2/chetvyorka-mechej.webp',
  'Четвёрка Пентаклей':'/cards/v2/chetvyorka-pentaklej.webp',
  'Четвёрка Жезлов':'/cards/v2/chetvyorka-zhezlov.webp',
  'Десятка Кубков':'/cards/v2/desyatka-kubkov.webp',
  'Десятка Мечей':'/cards/v2/desyatka-mechej.webp',
  'Десятка Пентаклей':'/cards/v2/desyatka-pentaklej.webp',
  'Десятка Жезлов':'/cards/v2/desyatka-zhezlov.webp',
  'Девятка Кубков':'/cards/v2/devyatka-kubkov.webp',
  'Девятка Мечей':'/cards/v2/devyatka-mechej.webp',
  'Девятка Пентаклей':'/cards/v2/devyatka-pentaklej.webp',
  'Девятка Жезлов':'/cards/v2/devyatka-zhezlov.webp',
  'Двойка Кубков':'/cards/v2/dvojka-kubkov.webp',
  'Двойка Мечей':'/cards/v2/dvojka-mechej.webp',
  'Двойка Пентаклей':'/cards/v2/dvojka-pentaklej.webp',
  'Двойка Жезлов':'/cards/v2/dvojka-zhezlov.webp',
  'Дьявол':'/cards/v2/dyavol.webp',
  'Иерофант':'/cards/v2/ierofant.webp',
  'Император':'/cards/v2/imperator.webp',
  'Императрица':'/cards/v2/imperatritsa.webp',
  'Колесница':'/cards/v2/kolesnitsa.webp',
  'Колесо Фортуны':'/cards/v2/koleso-fortuny.webp',
  'Король Кубков':'/cards/v2/korol-kubkov.webp',
  'Король Мечей':'/cards/v2/korol-mechej.webp',
  'Король Пентаклей':'/cards/v2/korol-pentaklej.webp',
  'Король Жезлов':'/cards/v2/korol-zhezlov.webp',
  'Королева Кубков':'/cards/v2/koroleva-kubkov.webp',
  'Королева Мечей':'/cards/v2/koroleva-mechej.webp',
  'Королева Пентаклей':'/cards/v2/koroleva-pentaklej.webp',
  'Королева Жезлов':'/cards/v2/koroleva-zhezlov.webp',
  'Луна':'/cards/v2/luna.webp',
  'Маг':'/cards/v2/mag.webp',
  'Мир':'/cards/v2/mir.webp',
  'Отшельник':'/cards/v2/otshelnik.webp',
  'Паж Кубков':'/cards/v2/pazh-kubkov.webp',
  'Паж Мечей':'/cards/v2/pazh-mechej.webp',
  'Паж Пентаклей':'/cards/v2/pazh-pentaklej.webp',
  'Паж Жезлов':'/cards/v2/pazh-zhezlov.webp',
  'Повешенный':'/cards/v2/poveshennyj.webp',
  'Пятёрка Кубков':'/cards/v2/pyatyorka-kubkov.webp',
  'Пятёрка Мечей':'/cards/v2/pyatyorka-mechej.webp',
  'Пятёрка Пентаклей':'/cards/v2/pyatyorka-pentaklej.webp',
  'Пятёрка Жезлов':'/cards/v2/pyatyorka-zhezlov.webp',
  'Рыцарь Кубков':'/cards/v2/rytsar-kubkov.webp',
  'Рыцарь Мечей':'/cards/v2/rytsar-mechej.webp',
  'Рыцарь Пентаклей':'/cards/v2/rytsar-pentaklej.webp',
  'Рыцарь Жезлов':'/cards/v2/rytsar-zhezlov.webp',
  'Семёрка Кубков':'/cards/v2/semyorka-kubkov.webp',
  'Семёрка Мечей':'/cards/v2/semyorka-mechej.webp',
  'Семёрка Пентаклей':'/cards/v2/semyorka-pentaklej.webp',
  'Семёрка Жезлов':'/cards/v2/semyorka-zhezlov.webp',
  'Шестёрка Кубков':'/cards/v2/shestyorka-kubkov.webp',
  'Шестёрка Мечей':'/cards/v2/shestyorka-mechej.webp',
  'Шестёрка Пентаклей':'/cards/v2/shestyorka-pentaklej.webp',
  'Шестёрка Жезлов':'/cards/v2/shestyorka-zhezlov.webp',
  'Шут':'/cards/v2/shut.webp',
  'Сила':'/cards/v2/sila.webp',
  'Смерть':'/cards/v2/smert.webp',
  'Солнце':'/cards/v2/solntse.webp',
  'Справедливость':'/cards/v2/spravedlivost.webp',
  'Суд':'/cards/v2/sud.webp',
  'Тройка Кубков':'/cards/v2/trojka-kubkov.webp',
  'Тройка Мечей':'/cards/v2/trojka-mechej.webp',
  'Тройка Пентаклей':'/cards/v2/trojka-pentaklej.webp',
  'Тройка Жезлов':'/cards/v2/trojka-zhezlov.webp',
  'Туз Кубков':'/cards/v2/tuz-kubkov.webp',
  'Туз Мечей':'/cards/v2/tuz-mechej.webp',
  'Туз Пентаклей':'/cards/v2/tuz-pentaklej.webp',
  'Туз Жезлов':'/cards/v2/tuz-zhezlov.webp',
  'Умеренность':'/cards/v2/umerennost.webp',
  'Верховная Жрица':'/cards/v2/verhovnaya-zhritsa.webp',
  'Влюблённые':'/cards/v2/vlyublyonnye.webp',
  'Восьмёрка Кубков':'/cards/v2/vosmyorka-kubkov.webp',
  'Восьмёрка Мечей':'/cards/v2/vosmyorka-mechej.webp',
  'Восьмёрка Пентаклей':'/cards/v2/vosmyorka-pentaklej.webp',
  'Восьмёрка Жезлов':'/cards/v2/vosmyorka-zhezlov.webp',
  'Звезда':'/cards/v2/zvezda.webp',
}
